var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0128 0.765591C1.57805 0.159965 2.52723 0.127234 3.13286 0.692485L6.60938 3.93724L10.0859 0.692485C10.6915 0.127234 11.6407 0.159965 12.206 0.765591C12.7712 1.37122 12.7385 2.3204 12.1329 2.88565L7.63286 7.08565C7.05655 7.62354 6.16221 7.62354 5.5859 7.08565L1.0859 2.88565C0.480277 2.3204 0.447547 1.37122 1.0128 0.765591Z",
    fill: "#8E8F98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdownArrow.21bc7668a70cf653ebd2183d98983a5a.svg";
export { ForwardRef as ReactComponent };